import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import classes from './Article.css';

class Article extends React.Component{

    render(){

        return (
            <div className={classes.Article}>

                <Container>
                    <div className={classes.Header}>
                    <Row>
                        <Col lg={{span: 8, offset: 2}}>
                            {this.props.header}
                        </Col>
                    </Row>
                    </div>

                    <div className={classes.Body}>    
                    {this.props.bodys.map((body, index) => (
                        <Row key={index}>
                            <Col lg={{span: 8, offset: 2}}>
                            { body }
                            </Col>
                        </Row>
                    ))}
                    </div>
                </Container>

            </div>
        )
    }
}

export default Article;


// WEBPACK FOOTER //
// ./src/components/Article/Article.js